import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M14.4996 20a.497.497 0 01-.239-.061l-5.261-2.869-5.261 2.869c-.168.092-.373.079-.529-.032s-.235-.301-.203-.49l.958-5.746-3.818-3.818a.5011.5011 0 01-.123-.506c.057-.178.209-.31.394-.341l5.749-.958 2.386-4.772c.085-.169.258-.276.447-.276s.363.107.447.276l2.386 4.772 5.749.958c.185.031.337.162.394.341.057.179.01.374-.123.506l-3.818 3.818.958 5.746a.5027.5027 0 01-.203.49.5027.5027 0 01-.29.093zm-5.5-4c.082 0 .165.02.239.061l4.599 2.508-.831-4.987a.4972.4972 0 01.14-.436l3.313-3.313-5.042-.84a.5004.5004 0 01-.365-.27l-2.053-4.106-2.053 4.106a.5029.5029 0 01-.365.27l-5.042.84 3.313 3.313a.502.502 0 01.14.436l-.831 4.987 4.599-2.508a.497.497 0 01.239-.061z',
  ],
  height: 20,
  width: 20,
});
